export default "__VITE_ASSET__CRVq41XJ__"